<template>
  <PopModal ref="modal" :title="$t('取消订单')">
    <div class="container">
      <van-form @submit="confirm">
        <div class="fw-600 fs-16 py-2 px-2">
          {{ $t("请选择取消订单的原因必选") }}
        </div>
        <template v-for="(item, index) in list">
          <div :key="index" class="px-1">
            <input
              :id="index"
              v-model="reason"
              :value="item"
              class="px-1"
              name="reason"
              required
              type="radio"
            />
            <label :for="index">&nbsp;{{ $t(item) }}</label>
          </div>
        </template>
        <van-field
          v-model="desc"
          :label="$t('留言')"
          :placeholder="$t('请输入留言')"
          autosize
          maxlength="150"
          rows="3"
          show-word-limit
          type="textarea"
        />
        <div style="margin: 16px;">
          <van-button
            :loading="loading"
            :loading-text="$t('submitting')"
            block
            native-type="submit"
            round
            small
            type="primary"
          >
            {{ $t("submit") }}
          </van-button>
        </div>
      </van-form>
    </div>
  </PopModal>
</template>
<script>
import PopModal from "@/components/PopModal.vue";

export default {
  props: {
    no: String
  },
  components: {
    PopModal
  },
  data() {
    return {
      desc: "",
      reason: "",
      loading: false,
      list: [
        "取消订单原因_不想要了",
        "取消订单原因_商品错选_多选",
        "取消订单原因_商品无货",
        "取消订单原因_地址信息填写错误",
        "取消订单原因_商品降价",
        "取消订单原因_价格高于其他平台",
        "取消订单原因_没用_少用_错用优惠"
      ]
    };
  },
  methods: {
    show() {
      this.$refs.modal.show();
    },
    confirm() {
      this.loading = true;
      this.$post("/user/goodsOrder/applyCancel", {
        no: this.no,
        refundBuyerDesc: this.desc,
        refundBuyerSelectReason: this.reason
      }).finally(() => {
        this.loading = false;
        this.$refs.modal.hide();
        this.$emit("confirm");
      });
    }
  }
};
</script>
